<template>
    <v-container fluid no-gutters class="my-0 py-0">
        <schedule-carousel v-if="matches.length" :matches="matches" />
        <v-row>
            <v-col cols="12" class="px-0">
                <template>
                    <v-data-table
                        v-if="type !== 'cup' && type !== 'playoffs'"
                        :headers="headers"
                        :items="ranking"
                        class="elevation-1  py-3 px-3 text-center"
                        hide-default-footer
                        disable-sort
                        :mobile-breakpoint="0"
                        :items-per-page="-1"
                        style="background: #232323; cursor: pointer;"
                        dark
                        @click:row="goToTeam"
                    >
                        <template v-slot:item.club="{ item }">
                            <v-row align="center" justify="center" :class="item.name === 'Varnava Hawks' ? 'overlay' : ''">
                                <v-col cols="3">
                                    <v-avatar style="border-radius: 10px;" size="35" color="white">
                                        <img
                                            v-if="item.imageUrl"
                                            :src="`${assetsUrl}/${item.imageUrl}`"
                                        >
                                        <v-icon v-else :style="$vuetify.breakpoint.mobile ? '' : 'font-size: 40px'" class="teal--text"> mdi-basketball-hoop </v-icon>
                                    </v-avatar>
                                </v-col>
                                <v-col cols="9">
                                    <span class="font-weight-bold">{{ item.name }}</span>
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.gp="{ item }">
                            <v-row align="center">
                                <v-col cols="12">
                                    {{ (item.won + item.lost) }}
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.win_percentage="{ item }">
                            <v-row align="center">
                                <v-col cols="12">
                                    {{ `${(item.won + item.lost) > 0 ? (item.won / (item.won + item.lost) * 100).toFixed(1) : 0}%` }}
                                </v-col>
                            </v-row>
                        </template>
                        <template v-slot:item.position="{ item }">
                            <v-row align="center">
                                <v-col cols="12">
                                    {{ ranking.indexOf(item) + 1 }}
                                </v-col>
                            </v-row>
                        </template>
                    </v-data-table>
                    <cup-bracket-board
                        v-else
                        :matches="cupMatches || []"
                    />
                </template>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import CupBracketBoard from '@/components/CupBracketBoard'
    import ScheduleCarousel from '@/components/ScheduleCarousel'

    export default {
        components: { CupBracketBoard, ScheduleCarousel },
        props: {
            type: {
                type: String,
                default: null
            },
            showFilters: {
                type: Boolean,
                default: true
            },
            ranking: {
                type: Array,
                default: null
            },
            matches: {
                type: Array,
                default: () => []
            },
            cupMatches: {
                type: Array,
                default: null
            }
        },
        data() {
            return {
                assetsUrl: 'https://storage.googleapis.com',
                headers: [
                    { text: 'Club', value: 'club', width: '200px', align: 'start' },
                    {
                        text: 'Pts.',
                        value: 'standing',
                        width: '30px',
                        align: 'center'
                    },
                    { text: 'GP', value: 'gp', width: '50px', align: 'center' },
                    { text: 'Won', value: 'won', width: '50px', align: 'center' },
                    { text: 'Lost', value: 'lost', width: '50px', align: 'center' },
                    { text: 'Win(%)', value: 'win_percentage', width: '50px', align: 'center' },
                    { text: 'Pts+', value: 'pointsPlus', width: '50px', align: 'center' },
                    { text: 'Pts-', value: 'pointsMinus', width: '50px', align: 'center' },
                    { text: '+/-', value: 'pointsDiff', width: '50px', align: 'center' }
                ],
                cupRound: 0
            }
        },
        watch: {
        },
        created() {
        },
        methods: {
            goToTeam(team) {
                this.$router.push({ name: 'Team', params: { id: team.id } })
            }
        }
    }
</script>

<style scoped>
.overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 15px;
    right: 0;
    height: 100%;
    width: 100%;
    opacity: 0.2;
}

.bg {
    position: absolute;

    /* background: url('../assets/basketball-bg-1.jpg'); */
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    width: 100%;
    height: auto;
    min-height: 100%;
}

.d4 {
    position: relative;
    max-height: 100%;
    overflow: auto;
}
</style>
